






















import { Component, Prop, Vue } from "vue-property-decorator";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import { processError } from "@/utils/ComponentUtils";

@Component({ components: { SingleFileHolder } })
export default class TaxPaymentDocument extends Vue {
  @Prop({ default: null }) readonly value!: FileMetaDTO | null;
  @Prop({ default: null }) readonly originalFile!: FileMetaDTO | null;
  private uploading = false;

  onUploading(uploading: boolean): void {
    this.uploading = uploading;
    this.$emit('uploading', uploading);
  }

  onUploadError(error: unknown): void {
    processError(error, this);
  }

  replace(): void {
    (this.$refs.holder as SingleFileHolder).uploadFile();
  }
}
